import { NgModule, NgZone, PLATFORM_ID } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AngularFireDatabaseModule } from '@angular/fire/database'

import { CommisionModalComponent } from './commision-modal/commision-modal.component'
import { ReferralDetailsComponent } from './referral-details/referral-details.component'
import { ReferralShellComponent } from './referral-shell/referral-shell.component'
import { ReferralsComponent } from './referrals-list/referrals.component'
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgxPaginationModule } from 'ngx-pagination'
import { CalendarModule } from 'primeng/calendar'
import { DropdownModule } from 'primeng/dropdown'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { TableModule } from 'primeng/table'
import { TabViewModule } from 'primeng/tabview'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { ComponentsModule } from 'src/app/components/components.module'
import { AppUsageComponent } from './app-usage/app-usage.component'
import { AppUsageTableComponent } from './app-usage/usage-table/usage-table.component'
import {
  FarmerAngularFireDatabase,
  FarmerAngularFireDatabaseFactory,
  AgentAngularFireDatabase,
  AgentAngularFireDatabaseFactory,
  FarmerFlutterFireDatabase,
  FarmerFlutterFireDatabaseFactory
} from './firebase'

@NgModule({
  declarations: [
    ReferralsComponent,
    ReferralDetailsComponent,
    CommisionModalComponent,
    ReferralShellComponent,
    AppUsageComponent,
    AppUsageTableComponent,
  ],
  imports: [
    CommonModule,
    AngularFireDatabaseModule,

    AppRoutingModule,
    ComponentsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TableModule,
    MultiSelectModule,
    CalendarModule,
    InputTextModule,
    DropdownModule,
    TabViewModule,
  ],
  providers: [
    {
      provide: FarmerAngularFireDatabase,
      deps: [PLATFORM_ID, NgZone],
      useFactory: FarmerAngularFireDatabaseFactory,
    },
    {
      provide: AgentAngularFireDatabase,
      deps: [PLATFORM_ID, NgZone],
      useFactory: AgentAngularFireDatabaseFactory,
    },
    {
      provide: FarmerFlutterFireDatabase,
      deps: [PLATFORM_ID, NgZone],
      useFactory: FarmerFlutterFireDatabaseFactory,
    },
  ],
})
export class UsageModule {}
